<template>
<div class="vcrbox-panel">
  <!-- <h3>{{ad.label || '相关推荐'}}</h3> -->
  <h3>相关推荐</h3>
  <div>
    <template v-for="(item, index) in ad.ideas">
      <VCRListImage :ad="item" :key="`image_${index}`" v-if="item.ideaType == 2" />
      <VCRListGraphic :ad="item" :key="`graphic_${index}`" v-if="item.ideaType == 3" />
      <VCRListTitle :ad="item" :key="`title_${index}`" v-if="item.ideaType == 4" />
    </template>
  </div>
</div>
</template>

<script>
import VueTypes from 'vue-types'
import gkAdEvent from 'gkui/ad/ADEvent'

import VCRListTitle from './VCRListTitle'
import VCRListImage from './VCRListImage'
import VCRListGraphic from './VCRListGraphic'

/**
 * 广告 - VCRBox
 * @desc 提供 VCRBox 广告展示模块
 * @module component/VCRBox
 * @extends ADEvent
 */
export default {
  name: 'vcrbox',
  /**
   * 引用的组件
   * @prop {Component}  gkAdEvent  广告组件
   */
  components: {
    gkAdEvent,
    VCRListTitle,
    VCRListImage,
    VCRListGraphic
  },
  /**
   * 传入数据
   */
  props: {
    ad: VueTypes.shape({
      label: VueTypes.string.def('相关推荐'),
      ideas: VueTypes.array.def([])
    }).loose
  },
  /**
   * 内部数据
   * @member
   */
  data () {
    return {
    }
  },
  /**
   * 计算属性
   */
  computed: {
    box () {
      return {
        visible: 'http://vcrbox.infoq.cn/box'
      }
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.vcrbox-panel {
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px 15px;
  background: #FFF;
  border: 1px solid $borderGray; border-radius: 3px;
}

h3 {
  position: relative;
  height: 34px;
  padding-bottom: 5px;
  line-height: 34px;
  // text-indent: 12px;
  @include font(20, 500);
  color: $lightBlack;
  
  // &:before {
  //   content: ' ';
  //   display: block;
  //   position: absolute; left: 0; top: 7px;
  //   width: 4px; height: 18px;
  //   background: $blue;
  //   pointer-events: none;
  // }
}

@media screen and (max-width: 768px) {
  .vcrbox-panel {
    padding: 0;
    border: none; border-radius: 0;
  }

  h3 {
    position: relative;
    height: 38px;
    line-height: 38px;
    text-indent: 12px;
    @include font(20, 500);
    
    &:before {
      content: ' ';
      display: block;
      position: absolute; left: 0; top: 9px;
      width: 4px; height: 18px;
      background: $blue;
      pointer-events: none;
    }
  }
}
</style>
